<div class="px-5 pb-60 max-w-screen-sm mx-auto md:max-w-full">
  <h1 class="py-6 font-accent font-bold text-2xl">
    {{ 'pay-at-table.user-checks.title' | translate }}
  </h1>
  <div
    *ngIf="!isChecksLoading; else loading"
    class="md:grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
  >
    <ng-container *ngIf="checks.length > 0; else noChecks">
      <div *ngFor="let check of checks">
        <app-check-card
          [check]="check"
          (cardClick)="goToCheckDetails($event.id)"
        ></app-check-card>
      </div>
    </ng-container>
    <ng-template #noChecks>
      <div class="text-center text-neutral-500 text-sm ng-star-inserted py-2">
        {{ 'orders.no-current-orders' | translate }}
      </div>
    </ng-template>
  </div>
  <ng-template #loading>
    <div class="mb-8xs">
      <ng-container *ngFor="let i of [].constructor(20)">
        <app-order-card-skeleton></app-order-card-skeleton>
      </ng-container>
    </div>
  </ng-template>
</div>
